export enum FilterParams {
  All = 'all',
  ACTIVE = 'active',
  COMPLETED = 'completed',
}
